import { authClient, API } from "../index";

export const getMigrationUsers = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.estado) queryParams.append("estado", params.estado);
  if (params.search) queryParams.append("search", params.search);

  return authClient().get(
    `${API}/payment/migration/users?${queryParams.toString()}`,
  );
};

export const getMigrationStats = () => {
  return authClient().get(`${API}/payment/migration/stats`);
};

export const getPaymentHistory = (userId) => {
  return authClient().get(`${API}/payment/history/${userId}`);
};

export const sendMigrationReminder = (userId) => {
  return authClient().post(`${API}/payment/migration/reminder/${userId}`);
};

export const updateMigrationNextPayment = (userId, proximoPago) => {
  return authClient().put(`${API}/payment/migration/users/${userId}/next-payment`, {
    proximoPago,
  });
};

export const getPaymentOperations = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.tipo) queryParams.append("tipo", params.tipo);
  if (params.estado) {
    const estadoParam = Array.isArray(params.estado)
      ? params.estado.join(",")
      : params.estado;
    queryParams.append("estado", estadoParam);
  }
  if (params.metodoPago) queryParams.append("metodoPago", params.metodoPago);
  if (params.search) queryParams.append("search", params.search);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  return authClient().get(
    `${API}/payment/operations?${queryParams.toString()}`,
  );
};

export const getPaymentOperationsStats = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  return authClient().get(
    `${API}/payment/operations/stats?${queryParams.toString()}`,
  );
};

export const chargeStudentPayment = (paymentId) => {
  return authClient().post(`${API}/payment/charge-student/${paymentId}`);
};

export const rejectStudent = (paymentId) => {
  return authClient().post(`${API}/payment/reject-student/${paymentId}`);
};

export const sendFailedCourseReminder = (paymentId) => {
  return authClient().post(
    `${API}/payment/failed-course-reminder/${paymentId}`,
  );
};
